import { z } from "zod";
import { endpoint } from "./endpoint.ts";

/**
 * Platform-wide launch switches. Each product line ships dark and is revealed by
 * an operator from the admin app (Paramètres plateforme); the admin pass owns the
 * toggle endpoint (PATCH /admin/platform/features). Public: the site and sign-up
 * read it before any session exists.
 */
export const PlatformFeatures = z.object({
  /**
   * Invoicing (boards F0–F23, DOC-*, MX2–MX7). Off: sign-up, the service picker,
   * menus and dashboards stay on the 2-service V1 designs and every
   * /app/facturation route is unreachable. On: the 3-service designs apply.
   */
  invoicing: z.boolean(),
});
export type PlatformFeatures = z.infer<typeof PlatformFeatures>;

export const platformApi = {
  features: endpoint({
    id: "platform.features",
    method: "GET",
    path: "/platform/features",
    response: PlatformFeatures,
    auth: false,
  }),
};
